module.exports = {
  "title": "collections", 
  "sub_text": "personalized content storyboards",
  "folders":{
    "new_folder_placeholder": "Enter a folder name",
    "delete_folder": "Delete all collections in the folder",
    "added": "added to folder",
    "removed" : "removed from folder",
  },
  "actions": {
    "rename": "Rename",
    "delete": "Delete",
    "clone": "Clone",
    "sort": {
      "sort_by": "Sort by",
      "name": "Name",
      "created": "Created",
      "modified": "Modified"
    },

    "add_new_folder": "Add new folder",
    "all_collections": "All collections",
    "owned_by_me": "Owned by me",
    "collaborated": "Collaborated",
    "live": "Live",
    "templates": "Templates",

    "create_collection": "Create New Collection",
    "uncategorized": "Uncategorized"

  },
  "error_messages":{
    "folder_name": "Please provide a valid name",
    "folder_name_length": "Folder name cannot be greater than 200 characters",
    "invalid_name": {
      "title": "Oh snap!",
      "sub_text": "Please provide a valid collection name"
    },
    "collection_not_exits": {
      "title": "Sorry!  Some one passed you the wrong information.",
      "sub_text":"Sorry!  Some one passed you the wrong information. You were never supposed to see me :). The collection does not exist any longer."
    },
    "no_access":{
      "title": "Who sets these rules, anyway?",
      "sub_text": "I'm sorry! It seems like I'm not authorised to show what you are looking for. I hate disappointing you :("
    }
  }, 
  "confirmation": {
    "rename": "Rename the collections and click here to",
    "delete": "Select content below and click here to",
    "clone": "Select on a collection to be cloned or",
    "delete_collection": {
      "title": "deleting",
      "sub_text": "Are you sure you would like to delete the selected collection/s?",
      "note": "Note: Shared collections will still be accessible by external recipients, except Deal Rooms, which will be deleted for everyone.",
      "description": "You can edit your deleted collections from your Conversations > Edit Collections."
    },
    "clone_collection": {
      "title": "cloning collection",
      "placeholder": "Add a collection name",
      "sub_text": "Get a head-start at building collections.",
      "description": "Cloning will create an exact copy of this collection so you can make finer edits and start sharing right away.",
    }
  },
  "uncategorized": {
    "title": "Embrace the chaos!",
    "sub_text": "Since we cannot hope for order, let us withdraw with style from the chaos. This is an automatically curated collection of all the content that are not a part of your collections or streams.",
    "confirmation": "Select content below and click here to",
    "error_message": "Select assets to delete.",
    "empty_message": "Looks like all your content belongs to a collection or a stream. Good job!",
    "actions": {
      "delete_assets": "Delete Assets"
    },
    "sliders": {
      "delete_assets": {
        "title": "deleting",
        "sub_text": "Are you sure you would like to delete the selected groups and assets?"
      }
    }
  },
  "sliders": {
    "create_collection": {
      "title": "create new collection",
      "placeholder": "Add a collection name",
      "sub_text": "Begin creating your collection here. Select the 'Collection Experience' and 'Viewer' that best suit your audience and content, then personalize it for a truly engaging experience. ",
      "description": "For detailed instructions and helpful tips, refer to our support articles.",
      "actions": {
        "change_experience": "Choose Experience",
        "experience": "Experience",
        "viewer_Type": "Viewer type"
      },
      "change_experience": {
        "title": "Choose Experience",
        "sub_text": "Choose the experience that best showcases your content and resonates with your audience. ",
        "collection_type": {
          "bento": {
            "title": "Bento",
            "sub_text": "A flexible wall to showcase your assets with unlimited possibilities for thumbnails and layouts."
          },
          "deal_room": {
            "title": "Deal room",
            "sub_text": "A collaborative workspace to share assets and engage with multiple stakeholders."
          },
          "metro": {
            "title": "Metro",
            "sub_text": "Present your assets in a vertical tile wall, complete with a customizable cover page."
          },
          "carousel": {
            "title": "Carousel",
            "sub_text": "Display your assets in an engaging carousel format that scrolls horizontally."
          }
        },
        "actions": {
          "next": "Choose Viewer"
        }
      },
      "choose_viewer": {
        "title": "Choose Viewer",
        "sub_text": "Select the viewer that best suits your content and audience for this collection.",
        "list_viewer": {
          "title": "List Viewer",
          "sub_text": "A dual-panel view, showcasing the full list on the left & individual assets in detail on the right."
        },
        "immerse_viewer": {
          "title": "Immerse Viewer",
          "sub_text": " Immerse yourself in each asset, with all content presented seamlessly up top."
        },
        "gallery_viewer": {
          "title": "Gallery Viewer",
          "sub_text": "Browse your collection like a photo gallery, with smooth scrolling and full-screen viewing."
        }
      }
    }
  },
  "collection": {
    "name": "Collection name:",
    "placeholder": "Provide collection name",
    "tooltips":{
      "live_collection_on": "Live Collection: ON",
      "template_on": "Template: ON",
      "internal_on": "Internal: ON",
      "internal_use_only": "Internal use only"
    },
    "header": {
      "actions": {
        "back": "Back",
        "add_asset": "Add Asset",
        "add_section": "Add Section",
        "edit_collection": "Edit Collection",
        "generate_link": "Generate Link",
        "add_logo": "Add Logo",
        "company_logo": "Company logo here",
        "edit_banner": "Edit Banner",
        "change_experience": "Change Experience",
        "change_viewer": "Change Viewer",
        "edit_deal_room": "Edit room",
        "track_activity": "Activity",
        "share": "Share",
        "switch_to_light": "Switch to light",
        "manage_people": "Manage People",
        "invite_people": "Invite People",
        "go_to_conversation": "Go to conversation",
        "more": {
          "collaborate": "Collaborate",
          "live_collection": "Live collection",
          "template": "Template",
          "internal_use_only": "Internal use only"
        }
      }
    },
    "error_message": {
      "logo_file_size": "File size can't be greater than 2MB"
    },
    "loading": {
      "collection": "Loading collection",
      "section": "Loading section"
    },
    "commons": {
      "add_assets": "Add assets to your collection",
      "actions": {
        "see_more": "See more",
        "see_less": "See less",
        "share_collection": "Share <br/> Collection",
        "save_changes": "Done with edits? Please",
        "add_to_section": "Add to section",
        "others": "Others"
      },
      "edit_banner": {
        "actions": {
          "add_banner": "Add Banner",
          "crop": "Crop",
          "filter": "Filter",
          "position": "Position",
          "show_shared_by": "Show shared by",
          "shared_by": "Shared by",
          "edit": "Edit"
        }
      },
      "empty_collection": {
          "title": "Make it your own",
          "sub_text": "Add the files you want to share from any source, and edit the look and feel to express your brand's personality.",
          "no_access": "This collection does not contain any Assets.",
          "actions": {
            "add_asset": "Add Asset"
          }   
      },
      "favourites_empty_message":{
        "title": "Show some love!",
        "sub_text": "You have not favorited any content yet.",
        "action": "Go to My collection"
      }
    },
    "sliders": {
      "add_section": {
        "title": "add section",
        "placeholder": "Enter a section name",
        "description": "Organizing your collection in sections is most suited when you have more than ten pieces of content to share.",
        "sub_text": "Add multiple sections as your content grows to structure your collection and help your audience get a birds eye view of your story board.",
        "error_message": "Please provide a valid section name"
      },
      "collaborate": {
        "title": "collaborate",
        "sub_text": "collaborate within your team, decide who can access this collection.",
        "placeholder": "Search users",
        "options": {
          "collaborators": "Collaborators",
          "view_all": "View All",
          "edit_all": "Edit All",
          "read": "Read",
          "write": "Write"
        },
        "empty_message": {
          "no_users" : "The user(s) that you were looking for was not found.",
          "no_collaborated_users": "You have'nt collaborated the collection with others"
        }
      },
      "live_collection": {
        "title": "live collection",
        "on_description": "Turning this feature ON will keep this collection live and in sync with all updates even after you've shared with recipients.",
        "off_description": "Turning this feature OFF will stop syncing any further changes to this collection for recipients you may have shared with.",
        "sub_text": "This collection was created on {0} and has been shared with {1}",
        "not_shared": "This collection was created on {0}. This collection wasn't shared with anyone.",
        "actions": {
          "notify_recipients": "Notify Recipients"
        },
        "compose": {
          "title": "Live Collection",
          "sub_text": "compose the mail here.",
          "was_updated": "was updated",
          "to": "to",
          "subject": "Subject",
          "subject_placeholder": "Enter subject",
          "hello_there": "Hello there",
          "changes": "We've recorded some changes to the content collection",
          "shared_by": "that was shared with you by"
        }
      },
      "template": {
        "title": "template",
        "on_description": "Turning this feature ON will mark this Collection as a template. All templates can be found in the `Template` folder.",
        "off_description": "Turning this feature OFF will remove this Collection from templates. All templates can be found in the `Template` folder."
      },
      "internal_use_only": {
        "title": "Internal use only",
        "on_description": "Turning this feature 'on' will indicate this collection is for Internal use only.",
        "off_description": "Turning this feature 'off' will mean this collection will no longer be marked for Internal use.",
        "on_sub_text": "Link generation and sharing functionalities will be disabled. Your team would not be able to share the collection with external users.",
        "off_sub_text": "Link Generation and Sharing functionalities will be enabled. Your team would be able to share the collection with external users."
      },
      "notify_recipients": {
        "title": "Notify Recipients",
        "live_collection_description": "This is a live collection. This feature keeps your collection live and in sync with all updates even after you've shared with recipients.",
        "sub_text": "This collection was created on {0} and has been shared with {1} recipients.",
        "description": "Would you like to notify the recipients of this collection about the changes you recently made?",
        "prior_recipients": "Prior Recipients",
        "actions": {
          "notify_recipients": "Notify Recipients"
        }
      }
    },
    "deal_room": {
      "add_assets": "Add assets to your deal room",
      "sidebar": {
        "overview": "Overview",
        "assets": "Assets",
        "collaborators": "People",
        "activity": "Activity",
        "need_help": "Need Help",
        "onboarding_subText": "Check how deal room works"
      },
      "overview_content":{
      "title": "Welcome to Paperflite’s Deal Room! Deal Room is your digital space for sharing content and collaborating with prospects, helping streamline sales processes and track buyer engagement in real time.",
      "sub_text": "Here's a quick guide to help you navigate and make the most out of this space",
      "footer_text": "Feel free to explore these sections to enhance your sales process and drive better engagement. Click on {0} to get started!",
      "add_company_logo": "Company logo here",
      "overview": {
        "title": "Overview",
        "sub_text": "This section sets the context for your deal room. It's the first screen your audience will see, so keep it crisp and clear. You can {0} using placeholders like asset count, first name, last name and brand colors to further personalise your buyer’s journey."
      },
      "collaborator": {
        "title": "People",
        "sub_text": "Who’s on your guest list? Invite and {0}, both internal and external, to keep them informed and involved in the sales cycles. "
      },
      "assets": {
        "title": "Assets",
        "sub_text": "View all uploaded documents from both parties in this section. Click on {0} to upload new documents."
      },
      "activity": {
        "title": "Activity",
        "sub_text": "See who did what and when! This includes document uploads and views by stakeholders. Use the {0} to guide relevant conversations based on the buyer’s journey. "
      },
    },
      "collaborators": {
        "room_created_by": "Room created by",
        "stakeholders": "Internal Stakeholders",
        "participants": "External Participants",
        "contributors": "Internal Contributors",
        "stakeholders_description": "Invite stakeholders from your company to keep them informed",
        "contributors_description": "Invite contributors from your company to get them involved",
        "external_stakeholders_description": "Invite external stakeholders to keep them informed and involved.",
        "no_people": "None added",
        "delete_confirmation": {
          "title": "Just confirming",
          "sub_text": "stakeholder",
          "description": "If you remove this stakeholder, they won't have access to the deal anymore. They can rejoin, but only with a new invite from you."
        },
        "actions": {
          "add_company_logo": "Company logo here",
          "invite_people": "Invite People",
          "add_people": "Add people"
        }
      },
      "resources": {
        "uploaded_content": "Uploaded Content",
        "customer_name": "Customer Name",
        "no_contents_added": "No contents added",
        "confirmation": {
          "heading": "deleting",
          "sub_text": "Are you sure you would like to delete the selected asset?"
        }
      },
      "activity": {
        "heading": "All Activities",
        "no_activity": {
          "title": "No activity found",
          "sub_text": "Looks like we've stumbled into the land of quiet! There's no activity here yet, but the night's still young"
        },
        "loading_message": {
          "text": "Loading more items",
          "load_more": "Load more"
        },
        "events": {
          "reshared": "reshared",
          "to": "to",
          "asset_added": "added",
          "on": "on"
        }
      }
    },
    "bento":{
        "save_changes" : "Done with edits? Please",
        "default_template_rearrange": "Switch to default layout"
    }
  },
  "empty_message": {
    "title": "Are you Everest? Because this folder is M-T!",
    "dnd": "Drag and drop your existing collections into this folder or create a new one here.",
    "no_collaborated": "Collaborated collections will show up here!",
    "no_live_collection": "Live collections will show up here!",
    "no_templates": "Templates will show up here!",
    "no_collection": "Create a new collection.",
    "customer": "Customer name can't be empty"
  }
}